<template>
  <div class="customer-detail">
    <header-top showBack haveTab></header-top>
    <div class="detail-header">
      <div class="header-left">
        <div class="flex-item">
          <div class="custom-intention" v-if="customer.intention">
            {{ customer.intention }}
          </div>
          <div class="header-name">{{ customer.name }}</div>
        </div>
        <div class="flex-item">
          <div class="attention-level" v-if="customer.attentionLevel">
            {{ customer.attentionLevel }}
          </div>
          <div class="margin-right header-item" v-if="reservationEstates.length">
            报备楼盘：
            <span v-for="(item,index) in reservationEstates" :key="index">{{item}}</span>
          </div>
          <div class="header-item">
            录入日期：{{ customer.creationTime | dateFormatYMD }}
          </div>
        </div>
      </div>
      <div class="header-right">
        <el-button icon="el-icon-edit" class="edit-btn" @click="editCustomer"
          >编辑客源</el-button
        >
        <el-button type="primary" icon="el-icon-edit-outline" @click="addFollow"
          >写跟进</el-button
        >
      </div>
    </div>
    <div class="main">
      <div class="main-left main-items">
        <div class="main-bgc">
          <div class="main-item">
            <div class="main-item-title">基础信息</div>
            <div class="main-item-container">
              <div class="flex-items">
                <div class="container-item">
                  <div>
                    <span class="item-label">用途：</span>
                    <span class="item-value">{{
                      customer.usingType | nullValue
                    }}</span>
                  </div>
                  <div>
                    <span class="item-label">最后跟进：</span>
                    <span class="item-value">{{
                      customer.lastFollowTime | dateFormatYMD
                    }}</span>
                  </div>
                  <div>
                    <span class="item-label">归属人</span>
                    <span class="item-value">{{
                      customer.creatorName | nullValue
                    }}</span>
                  </div>
                </div>
                <div class="container-item">
                  <div>
                    <span class="item-label">来源：</span>
                    <span class="item-value">{{
                      customer.sourceType | nullValue
                    }}</span>
                  </div>
                  <div>
                    <span class="item-label">最后带看：</span>
                    <span class="item-value">{{
                      customer.lastVisitTime | dateFormatYMD
                    }}</span>
                  </div>
                  <div>
                    <span class="item-label">证件号码：</span>
                    <span class="item-value">{{
                      customer.idNumber | nullValue
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="main-item">
            <div class="main-item-title">求购信息</div>
            <div class="main-item-container">
              <div class="flex-items">
                <div class="container-item">
                  <div>
                    <span class="item-label">购房目的：</span>
                    <span class="item-value">{{
                      customer.buyPurpose | nullValue
                    }}</span>
                  </div>
                  <div>
                    <span class="item-label">居室：</span>
                    <span
                      class="item-value item-values"
                      v-for="(item, index) in customer.houseTypes"
                      :key="index"
                      >{{ item }}
                    </span>
                    <span v-if="!customer.houseTypes.length">—</span>
                  </div>
                  <div>
                    <span class="item-label">装修：</span>
                    <span
                      class="item-value item-values"
                      v-for="(item, index) in customer.decorations"
                      :key="index"
                      v-show="customer.decorations.length"
                      >{{ item }}
                    </span>
                    <span v-if="!customer.decorations.length">—</span>
                  </div>
                  <div>
                    <span class="item-label">楼层：</span>
                    <span
                      class="item-value item-values"
                      v-for="(item, index) in customer.floorTypes"
                      v-show="customer.floorTypes.length"
                      :key="index"
                      >{{ item }}
                    </span>
                    <span v-if="!customer.floorTypes.length">—</span>
                  </div>
                  <div>
                    <span class="item-label">付款方式：</span>
                    <span class="item-value">{{
                      customer.payType | nullValue
                    }}</span>
                  </div>
                  <div>
                    <span class="item-label">预计入学时间：</span>
                    <span class="item-value">{{
                      customer.schoolTime | dateFormatYMD
                    }}</span>
                  </div>
                </div>
                <div class="container-item">
                  <div>
                    <span class="item-label">总价：</span>
                    <span class="item-value"
                      >{{ customer.minTotalPrice }} -
                      {{ customer.maxTotalPrice }} 万元</span
                    >
                  </div>
                  <div>
                    <span class="item-label">面积：</span>
                    <span class="item-value"
                      >{{ customer.minArea }} -
                      {{ customer.maxArea }} ㎡</span
                    >
                  </div>
                  <div>
                    <span class="item-label">朝向：</span>
                    <span
                      class="item-value item-values"
                      v-for="(item, index) in customer.orientationType"
                      v-show="customer.orientationType.length"
                      :key="index"
                      >{{ item }}
                    </span>
                    <span v-if="!customer.orientationType.length">—</span>
                  </div>
                  <div>
                    <span class="item-label">交通：</span>
                    <span class="item-value">{{
                      customer.traffic | nullValue
                    }}</span>
                  </div>
                  <div>
                    <span class="item-label">意向学校：</span>
                    <span
                      class="item-value item-values"
                      v-for="(item, index) in customer.schools"
                      v-show="customer.schools.length"
                      :key="index"
                      >{{ item }}
                    </span>
                    <span v-if="!customer.schools.length">—</span>
                  </div>
                  <div>
                    <span class="item-label">意向小区：</span>
                    <span
                      class="item-value item-values"
                      v-for="(item, index) in customer.communities"
                      v-show="customer.communities.length"
                      :key="index"
                      >{{ item }}
                    </span>
                    <span v-if="!customer.communities.length">—</span>
                  </div>
                </div>
              </div>
              <div>
                <span class="item-label">意向商圈：</span>
                <span
                  class="item-value item-values"
                  v-for="(item, index) in customer.addresses"
                  :key="index"
                  >{{ item.city }}
                  -
                  {{ item.district }}
                  -
                  {{ item.street }}
                  -
                  {{ item.business }}
                </span>
                <span v-if="!customer.addresses.length">—</span>
              </div>
            </div>
          </div>
          <div class="main-item">
            <div class="main-item-title">报备信息</div>
            <div class="main-item-container">
              <el-table :data="reservations" style="width: 100%" stripe>
                <el-table-column type="expand" width="50">
                  <template slot-scope="scope">
                    <div class="flex-box">
                      <el-image
                        :src="
                          scope.row.estateInfo.photoCoverUrl
                            ? scope.row.estateInfo.photoCoverUrl
                            : defaultCover
                        "
                        :preview-src-list="
                          scope.row.estateInfo.photoCoverUrl
                            ? [scope.row.estateInfo.photoCoverUrl]
                            : []
                        "
                        lazy
                      ></el-image>
                      <div class="estate-info">
                        <div
                          class="estate-name"
                          @click="goEstateDetail(scope.row.estateId)"
                        >
                          {{ scope.row.estateName }}
                        </div>
                        <div>
                          {{ scope.row.estateInfo.district }} -
                          {{ scope.row.estateInfo.street }}
                        </div>
                        <div>
                          <div class="estate-status">
                            {{ scope.row.estateInfo.saleStatus }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="报备楼盘" prop="estateName">
                </el-table-column>
                <el-table-column
                  label="报备时间"
                  prop="creationTime"
                  sortable
                >
                </el-table-column>
                <el-table-column label="经纪人" prop="creatorName">
                  <template slot-scope="scope">
                    {{ scope.row.creatorName | nullValue }}
                  </template>
                </el-table-column>
                <el-table-column label="状态" prop="flowStatus">
                </el-table-column>
                <el-table-column width="80" label="管理">
                  <template slot-scope="scope">
                    <span
                      class="theme-color"
                      @click="goReservationDetail(scope.row.id)"
                      >详情</span
                    >
                  </template>
                </el-table-column>
                
              </el-table>
            </div>
          </div>
          <div class="main-item">
            <div class="main-item-title">成交房源</div>
            <div class="main-item-container">
              <el-table :data="finishes" border class="sort-table">
                <el-table-column prop="estateName" label="成交房源">
                </el-table-column>
                <el-table-column prop="finishTime" label="成交日期" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.finishTime | dateFormat }}
                  </template>   
                </el-table-column>
                <el-table-column prop="creatorName" label="成交方">
                  <template slot-scope="scope">
                    {{ scope.row.creatorName | nullValue }}
                  </template>
                </el-table-column>
                <el-table-column prop="finishPrice" label="成交价格" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.finishPrice?scope.row.finishPrice+'万元':'—' }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div class="main-right main-items">
        <div class="main-bgc">
          <div class="main-item">
            <div class="main-item-container">
              <div class="customer-top">
                <div>
                  <span class="customer-name">{{ customer.name }}</span>
                  <span class="customer-gender"
                    >（{{ customer.gender }}/客户）</span
                  >
                </div>
                <el-button
                  plain
                  size="mini"
                  @click="switchShowPhone(false)"
                  v-if="isShowPhone"
                  >隐藏号码</el-button
                >
                <el-button
                  plain
                  size="mini"
                  @click="switchShowPhone(true)"
                  v-else
                  >查看号码</el-button
                >
              </div>
              <div class="customer-phone">
                {{ customer.phoneNumber }}
              </div>
              <div class="customer-btns">
                <el-popover
                  placement="bottom-start"
                  popper-class="customer-popover"
                  trigger="click"
                  width="347"
                >
                  <div class="customer-contracts" v-if="canLookContract">
                    <div
                      v-for="(item, index) in contracts"
                      :key="index"
                      class="contracts-item"
                    >
                      <div class="flex-item">
                        <div>
                          <span class="contracts-name">{{ item.name }}</span>
                          <span class="contracts-gender"
                            >（{{ item.gender }}/客户）</span
                          >
                        </div>
                        <div>
                          <span class="contracts-edit" @click="editContract(item)">编辑</span>
                          <span class="contracts-del" @click="delContract(item.id)">删除</span>
                        </div>
                      </div>
                      <div class="phone-item">
                        <span v-for="(el, i) in item.phoneNumbers" :key="i">
                          <span>
                            {{ item.phoneNumbers[0] }}
                          </span>
                        </span>
                      </div>
                      <div class="contract-detail">
                        <div>
                          <span class="detail-label">微信</span>
                          <span class="detail-value">{{
                            item.weChat | nullValue
                          }}</span>
                        </div>
                        <div>
                          <span class="detail-label">QQ</span>
                          <span class="detail-value">{{
                            item.qq | nullValue
                          }}</span>
                        </div>
                        <div>
                          <span class="detail-label">备注</span>
                          <span class="detail-value">{{
                            item.more | nullValue
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="!contracts.length">暂无联系人</div>
                  </div>
                  <div class="customer-contracts can-not" v-else>
                    您暂无权限查看联系人
                  </div>
                  <div slot="reference" class="btn-text">全部联系人</div>
                </el-popover>
                <div class="btn-line"></div>
                <div class="btn-text" @click="addContract">新增</div>
              </div>
              <el-button type="primary" class="customer-btn" @click="lookLog"
                >查看客户/联系人操作日志</el-button
              >
            </div>
          </div>
          <div class="main-item">
            <div class="main-item-title">操作</div>
            <div class="main-item-container">
              <div class="flex-items">
                <div class="flex-item">
                  <div class="item-main" @click="editFollowLevel">
                    <img src="@/assets/image/grade.png" />
                    <div>
                      <span>改等级</span>
                    </div>
                  </div>
                </div>
                <div class="flex-item">
                  <div class="item-main" @click="customerDeal">
                    <!-- <div class="item-main"> -->
                    <img src="@/assets/image/deals.png" />
                    <div>
                      <span>客户成交</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="main-item follow-record">
            <div class="main-item-title">跟进记录</div>
            <div class="main-item-container">
              <div class="follow-items" v-if="follows.length">
                <div
                  class="follow-item"
                  v-for="(item, index) in follows"
                  :key="index"
                >
                  <div class="item-line">
                    <div
                      class="circle"
                      :class="{ 'latest-circle': index == follows.length - 1 }"
                    ></div>
                    <div class="line" v-if="index != 0"></div>
                  </div>
                  <img src="@/assets/image/follow-header.png" />
                  <div class="margin-bottom">
                    <div class="follow-purpose">【{{ item.purpose }}】</div>
                    <div>
                      <span v-if="item.creatorName"
                        >{{ item.creatorName }} </span
                      ><span>{{ item.creationTime }}</span>
                    </div>
                    <div>{{ item.content }}</div>
                  </div>
                </div>
              </div>
              <div v-else>暂无记录</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="写跟进"
      :visible.sync="isFollowShow"
      @close="handleClose('followForm')"
    >
      <el-form
        label-position="left"
        label-width="5rem"
        ref="followForm"
        :rules="followRules"
        :model="followForm"
      >
        <el-form-item label="跟进目的" prop="purpose">
          <el-select
            v-model="followForm.purpose"
            clearable
            placeholder="请选择跟进目的"
          >
            <el-option
              v-for="item in purposeOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跟进内容" prop="content" class="auto-height">
          <el-input
            type="textarea"
            v-model="followForm.content"
            placeholder="请填写跟进内容（至少6个字）"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-button @click="isFollowShow = false">取 消</el-button>
          <el-button type="primary" @click="submitFollow" :loading="isLoading"
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="contractTitle"
      :visible.sync="isContractShow"
      @close="handleClose('contractForm')"
    >
      <el-form
        label-position="left"
        label-width="5rem"
        ref="contractForm"
        :rules="contractRules"
        :model="contractForm"
      >
        <div class="flex-items">
          <div class="flex-item">
            <el-form-item label="姓名" prop="name">
              <el-input
                v-model="contractForm.name"
                placeholder="请输入姓名"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item label="性别" prop="gender">
              <el-radio-group v-model="contractForm.gender">
                <el-radio
                  v-for="item in genderOptions"
                  :label="item"
                  :key="item"
                  >{{ item }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item label="手机号1" prop="phone1">
              <el-input
                v-model="contractForm.phone1"
                placeholder="请输入手机号"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex-item">
            <el-form-item label="微信号" prop="weChat">
              <el-input
                v-model="contractForm.weChat"
                placeholder="请输入微信号"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item label="QQ" prop="qq">
              <el-input
                v-model="contractForm.qq"
                placeholder="请输入QQ号"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item label="手机号2" prop="phone2">
              <el-input
                v-model="contractForm.phone2"
                placeholder="请输入手机号"
                clearable
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="备注" class="auto-height" prop="more">
          <el-input
            class="contract-more"
            type="textarea"
            maxlength="200"
            v-model="contractForm.more"
            placeholder="请输入备注"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-button @click="isContractShow = false">取 消</el-button>
          <el-button
            type="primary"
            @click="submitContractForm"
            :loading="isLoading"
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="客户/联系人操作日志"
      :visible.sync="isLogShow"
      @close="handleClose('log')"
      class="dialog-auto dialog-log"
    >
      <div class="operation flex">
        <div class="key margin-left">日期</div>
        <el-date-picker
          @change="dateRangeChange"
          v-model="dateRange"
          type="daterange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <div class="key">操作类型</div>
        <el-select
          v-model="queryLog.actionCode"
          placeholder="请选择操作类型"
          @change="getHistorypages"
          clearable
        >
          <el-option
            v-for="item in historyActions"
            :key="item.actionCode"
            :label="item.actionName"
            :value="item.actionCode"
          >
          </el-option>
        </el-select>
        <el-input
          :placeholder="searchText"
          v-model="searchValue"
          class="input-with-select"
          clearable
        >
          <el-select
            v-model="search"
            slot="prepend"
            placeholder="楼盘名称"
            @change="filterSelect"
          >
            <el-option
              v-for="item in searchOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getHistorypages"
          ></el-button>
        </el-input>
        <div class="clear theme-color" @click="clearHistoryFilter">清空条件</div>
      </div>
      <el-table :data="historyList" border @sort-change="changeSort" ref="historyTable" class="sort-table">
        <el-table-column prop="creationTime" label="操作时间" sortable>
        </el-table-column>
        <el-table-column prop="operatorName" label="操作人"> </el-table-column>
        <el-table-column prop="actionCode" label="操作类型">
          <template slot-scope="scope">
            <span>{{ actionCodeFilter(scope.row.actionCode) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="actionCode" label="操作内容">
          <template slot-scope="scope">
            <div v-if="scope.row.title">{{scope.row.title}}<span class="theme-color" @click="lookDetail(scope.row)">（查看详情）</span></div>
            <span v-html="scope.row.content" v-else></span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageIndex"
        :page-sizes="[10, 20, 30]"
        :page-size="queryLog.maxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </el-dialog>
    <el-dialog
      title="改客户等级"
      :visible.sync="isAttentionLevelShow"
      @close="handleClose('attentionLevelForm')"
    >
      <el-form
        label-position="left"
        label-width="5rem"
        ref="attentionLevelForm"
        :rules="attentionLevelRules"
        :model="attentionLevelForm"
      >
        <el-form-item label="原等级">
          {{ customer.attentionLevel ? customer.attentionLevel : "--" }}
        </el-form-item>
        <el-form-item label="修改为" prop="attentionLevel">
          <el-select
            v-model="attentionLevelForm.attentionLevel"
            clearable
            placeholder="请选择客户等级"
          >
            <el-option
              v-for="item in attentionLevelOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-button @click="isAttentionLevelShow = false">取 消</el-button>
          <el-button
            type="primary"
            @click="submitAttentionLevel"
            :loading="isLoading"
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="客户成交"
      custom-class="dialog-netSign dialog-auto"
      @close="handleClose('netSignForm')"
      :visible.sync="isNetSignShow"
    >
      <el-form
        :model="netSignForm"
        ref="netSignForm"
        :rules="netSignRules"
        label-width="6rem"
        label-position="left"
      >
        <el-form-item prop="reportId" label="报备单">
          <div v-if="netSignForm.reportId">
            {{ netSignForm.reportId }}
          </div>
          <div v-else class="selset-report" @click="isSelectReportShow = true">
            <i class="el-icon-plus"></i>选择报备单
          </div>
        </el-form-item>
        <el-form-item label="房源" class="auto-height" required>
          <div class="build-tit" v-if="houseName">{{ houseName }}</div>
          <div class="house-info">
            <el-form-item prop="buildingNumber">
              <el-input v-model="netSignForm.buildingNumber"></el-input
              ><span class="unit">栋</span>
            </el-form-item>
            <el-form-item prop="unitNumber">
              <el-input v-model="netSignForm.unitNumber"></el-input
              ><span class="unit">单元</span>
            </el-form-item>
            <el-form-item prop="houseNumber">
              <el-input v-model="netSignForm.houseNumber"></el-input
              ><span class="unit">号</span>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item prop="netSignTime" label="成交日期">
          <el-date-picker
            v-model="netSignForm.netSignTime"
            align="center"
            type="date"
            placeholder="请选择成交日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="price" label="成交价格">
          <el-input
            class="reason-box"
            v-model="netSignForm.price"
            type="number"
            placeholder="请输入成交价格"
          >
            <template slot="append">万元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="附件" class="auto-height">
          <div class="visit-img">
            <div
              class="photo-item"
              v-for="(item, index) in netSignFiles"
              :key="index"
            >
              <div class="img-box">
                <img :src="item.url" class="photo-img" />
                <div class="del-btn">
                  <span @click="delDealImg(index)">删除</span>
                </div>
              </div>
            </div>
            <el-upload
              v-if="netSignFiles.length < 5"
              ref="upload"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-change="handleNetSignPreview"
              :file-list="netSignFiles"
              :show-file-list="false"
              :auto-upload="false"
              multiple
              accept=".jpg, .png, .jpeg"
            >
              <div class="upload-btn">
                <i slot="default" class="el-icon-plus"></i>
                <span>上传图片</span>
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item prop="more" label="备注" class="auto-height">
          <el-input
            class="reason-box"
            type="textarea"
            v-model="netSignForm.more"
            maxlength="200"
            placeholder="请输入备注"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isNetSignShow = false">取消</el-button>
        <el-button type="primary" :loading="isLoading" @click="submitNetSign"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="选择报备单"
      :visible.sync="isSelectReportShow"
      @close="handleClose('selectReport')"
    >
      <el-table
        :data="reports"
        ref="reportTable"
        stripe
        style="width: 100%"
        :select-on-indeterminate="false"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          label="报备编号"
          prop="id"
          width="300"
        ></el-table-column>
        <el-table-column
          label="楼盘名称"
          prop="estateName"
          width="150"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="客户姓名" prop="customerName"></el-table-column>
        <el-table-column
          label="经纪人姓名"
          prop="creatorName"
          width="100"
        ></el-table-column>
        <el-table-column label="状态" prop="reviewStatus"></el-table-column>
        <el-table-column
          label="提交时间"
          sortable
          width="150"
          prop="lastModificationTime"
        >
        </el-table-column>
        <template slot="empty">
          <div class="empty-box" v-if="!reports.length">列表为空</div>
        </template>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <div>
          <el-button @click="isSelectReportShow = false">取 消</el-button>
          <el-button type="primary" @click="submitSelectReport"
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-drawer
      :with-header="false"
      :visible.sync="isHistoryShow"
      direction="rtl"
    >
      <div class="drawer-title">
        {{historyTitle}}
        <span @click="isHistoryShow = false">
          <svg-icon icon-class="close-ico" />
        </span>
      </div>
      <div class="history-content" v-html="historyContent" v-if="historyContent">
      </div>
      <div class="history-content" v-else>暂无内容</div>
    </el-drawer>
  </div>
</template>

<script>
import indexJs from "./index.js";
export default {
  ...indexJs,
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>